import React from 'react'

class Angle extends React.Component {
  // constructor () {
  //   super()
  //   // this.state = { someKey: 'someValue' };
  // }

  render () {
    return (
      <svg className='angle-down' x='0px' y='0px' width='16px' height='10px' viewBox='0 0 16 10' xmlSpace='preserve'>
        <path fillRule='evenodd' d='M15.322,1.648l-6.834,7.45C8.467,9.129,8.474,9.17,8.447,9.199
          C8.323,9.322,8.16,9.375,7.999,9.367C7.838,9.375,7.677,9.32,7.555,9.197C7.527,9.17,7.534,9.131,7.514,9.1L0.68,1.649
          c-0.232-0.233-0.232-0.61,0-0.842s0.609-0.232,0.842,0L8,7.871l6.479-7.064c0.232-0.233,0.609-0.233,0.843,0
          C15.553,1.039,15.553,1.416,15.322,1.648z' />
      </svg>
    )
  }
}

export default Angle



// WEBPACK FOOTER //
// ./src/components/Angle/index.js